import { render, staticRenderFns } from "./FirmwareVersion.vue?vue&type=template&id=4b22dbd3&scoped=true&"
import script from "./FirmwareVersion.vue?vue&type=script&lang=ts&"
export * from "./FirmwareVersion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b22dbd3",
  null
  
)

export default component.exports